export enum MetricType {
  END_SELLER_MANAGEMENT = 'END_SELLER_MANAGEMENT',
  MOBILE_NETWORK = 'MOBILE_NETWORK',
  BRANDVO_GROWTH = 'BRANDVO_GROWTH',
  END_USER_METRICS = 'endUserMetrics',
  TELECOM = 'telecom',
  SELLER = 'seller',
  BRANDIQ_BASIC_DATA_COLLECTION_FUNNEL = 'brandIqBasicDataCollectionFunnel',
  BRANDIQ_BASIC_APP_INSIGHTS = 'brandIqBasicAppInsight',
}
